import React from "react";
import CustomTranslation from "../../Components/CustomTranslation";
import { Button, Table, Modal, Image } from "react-bootstrap";
import G from "../../../Actions/GeneralAction";
import TranslationAction from "../../../Actions/TranslationAction";
import APIAction from "../../../Actions/APIAction";
import LanguageRepository from "../../../Database/Repositories/LanguageRepository";
import fileDownload from "js-file-download";
import { generatePath } from "react-router-dom";

//define class
class ToolboxItem extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //init state
        this.state = {
            showModal: false,
            downloadingFile: false,
            downloadModal: false
        };
    }
    //download pdf
    downloadFile = () => {
        this.setState({ downloadingFile: true }, async () => {
            //default file name
            let now = new Date();
            let fileName = await TranslationAction.translate('KEY.Toolbox');
            fileName += ' ' + now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
            fileName += '.pdf';

            //get language
            let languageRepository = new LanguageRepository();
            let language = await languageRepository.getSelected();

            //request
            APIAction.request('/assignments/' + this.props.data.assignments[0].id + '/pdf', 'GET', true, { language: language.code }, true, false, 'json', true)
                .then(result => {
                    fileName = fileName.replace(/['"]+/g, '');
                    fileDownload(result, fileName, 'application/pdf');
                    this.setState({ downloadingFile: false });
                });
        });
    }

    //render view
    render = () => {
        return (
            <div style={this.props.style} className={this.props.className}>
                <h4><CustomTranslation value={'KEY.Toolbox'} /></h4>
                {/* Table */}
                <Table striped bordered>
                    <tbody>
                        <tr>
                            <th><CustomTranslation value={'KEY.Company'} /></th>
                            <td>{this.props.data.constructionSite.company.name}</td>
                        </tr>
                        <tr>
                            <th><CustomTranslation value={'KEY.Construction Site'} /></th>
                            <td>{this.props.data.constructionSite.name}</td>
                        </tr>
                        <tr>
                            <th><CustomTranslation value={'KEY.Created by'} /></th>
                            <td>{(this.props.data.createdBy.firstName && this.props.data.createdBy.lastName) ?
                                this.props.data.createdBy.firstName + ' ' + this.props.data.createdBy.lastName :
                                this.props.data.createdBy.email
                            }</td>
                        </tr>
                        <tr>
                            <th><CustomTranslation value={'KEY.Created at'} /></th>
                            <td>{G.formatDateTime(this.props.data.createdAt)}</td>
                        </tr>
                    </tbody>
                </Table>
                {/* Buttons */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flexBasis: 1, flexGrow: 1, marginLeft: 0 }} className={'standard-margin-3'}>
                        <Button
                            block
                            variant={'dark'}
                            onClick={() => this.setState({ showModal: true })}
                        >
                            <CustomTranslation value={'KEY.More'} />
                        </Button>
                    </div>
                    <div style={{ flexBasis: 1, flexGrow: 1, marginRight: 0 }} className={'standard-margin-3'}>
                        <Button
                            block
                            variant={'dark'}
                            disabled={this.state.downloadingFile}
                            onClick={async () => {
                                this.setState({ downloadModal: true });
                            }}
                        >
                            <CustomTranslation value={'KEY.Download'} />
                        </Button>
                    </div>
                </div>
                {(this.props.data.assignments[0].sender.id === this.props.user.id || this.props.data.assignments[0].targetUser.id === this.props.user.id) &&
                    <Button
                        style={{ marginTop: 6 }}
                        block
                        variant={'dark'}
                        onClick={() => {
                            if (this.props.data.assignments[0].targetUser.id === this.props.user.id) {
                                window.location.href = generatePath('/construction_site/:cs_id/assignment/:id/in', { cs_id: this.props.data.constructionSite.id, id: this.props.data.assignments[0].id });
                            } else {
                                window.location.href = generatePath('/construction_site/:cs_id/assignment/:id/out', { cs_id: this.props.data.constructionSite.id, id: this.props.data.assignments[0].id });
                            }
                        }}
                    >
                        <CustomTranslation value={'KEY.To'} /> <CustomTranslation value={'KEY.Toolbox'} />
                    </Button>
                }

                {/* Modal */}
                <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })} backdrop={'static'} keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <CustomTranslation value={'KEY.Toolbox'} />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Full Table */}
                        <Table striped bordered>
                            <tbody>
                                {this.props.data.assignments[0].photo &&
                                    <>
                                        <tr>
                                            <th colSpan={2}><CustomTranslation value={'KEY.Image overview'} /></th>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className={'d-flex flex-row justify-content-center'}>
                                                    <Image /*height={300}*/ style={{ maxWidth: '100%', maxHeight: '30rem' }} src={this.props.data.assignments[0].photo.resizedPath} rounded />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                }
                                {this.props.data.assignments[0].altPhoto &&
                                    <>
                                        <tr>
                                            <th colSpan={2}><CustomTranslation value={'KEY.Instruction/Toolboxmoment'} /></th>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className={'d-flex flex-row justify-content-center'}>
                                                    <Image height={300} style={{ maxWidth: '100%', maxHeight: '30rem' }} src={this.props.data.assignments[0].altPhoto.resizedPath} rounded />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                }
                                <tr>
                                    <th><CustomTranslation value={'KEY.From'} /></th>
                                    <td>
                                        {(this.props.data.assignments[0].sender.firstName || this.props.data.assignments[0].sender.lastName)
                                            ?
                                            (this.props.data.assignments[0].sender.firstName || '') + ' ' + (this.props.data.assignments[0].sender.lastName || '')
                                            :
                                            (this.props.data.assignments[0].sender.email || '')
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><CustomTranslation value={'KEY.To'} /></th>
                                    <td>
                                        {(this.props.data.assignments[0].targetUser.firstName || this.props.data.assignments[0].targetUser.lastName)
                                            ?
                                            (this.props.data.assignments[0].targetUser.firstName || '') + ' ' + (this.props.data.assignments[0].targetUser.lastName || '')
                                            :
                                            (this.props.data.assignments[0].targetUser.email || '')
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th><CustomTranslation value={'KEY.Date'} /></th>
                                    <td>
                                        {G.formatDate(this.props.data.assignments[0].createdAt)}
                                    </td>
                                </tr>
                                <tr>
                                    <th><CustomTranslation value={'KEY.Title'} /></th>
                                    <td>{this.props.data.assignments[0].title ?? ''}</td>
                                </tr>
                                <tr>
                                    <th><CustomTranslation value={'KEY.Solve by'} /></th>
                                    <td>{G.formatDate(this.props.data.assignments[0].dateRequested)}</td>
                                </tr>
                                <tr>
                                    <th><CustomTranslation value={'KEY.Optional extra information'} /></th>
                                    <td>{G.nl2br(this.props.data.assignments[0].immediateActionTaken)}</td>
                                </tr>

                                {this.props.data.assignments[0].dateFinished &&
                                    <React.Fragment>
                                        <tr>
                                            <th><CustomTranslation value={'KEY.Finished on'} /></th>
                                            <td>
                                                {G.formatDate(this.props.data.assignments[0].dateFinished)}
                                            </td>
                                        </tr>
                                        {this.props.data.assignments[0].comment &&
                                            <tr>
                                                <th><CustomTranslation value={'KEY.Follow-up'} /></th>
                                                <td>
                                                    {G.nl2br(this.props.data.assignments[0].comment)}
                                                </td>
                                            </tr>
                                        }
                                    </React.Fragment>
                                }
                                {this.props.data.assignments[0].followUpPhoto &&
                                    <>
                                        <tr>
                                            <th colSpan={2}><CustomTranslation value={'KEY.Image overview follow-up'} /></th>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className={'d-flex flex-row justify-content-center'}>
                                                    <Image /*height={300}*/ style={{ maxWidth: '100%', maxHeight: '30rem' }} src={this.props.data.assignments[0].followUpPhoto.resizedPath} rounded />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                }
                                {this.props.data.assignments[0].followUpAltPhoto &&
                                    <>
                                        <tr>
                                            <th colSpan={2}><CustomTranslation value={'KEY.Image detail follow-up'} /></th>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                <div className={'d-flex flex-row justify-content-center'}>
                                                    <Image /*height={300}*/ style={{ maxWidth: '100%', maxHeight: '30rem' }} src={this.props.data.assignments[0].followUpAltPhoto.resizedPath} rounded />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                }
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button block variant={'dark'} onClick={() => this.setState({ showModal: false })}>
                            <CustomTranslation value={'KEY.Close'} />
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Download modal */}
                <Modal show={this.state.downloadModal} onHide={() => this.setState({ downloadModal: false })} backdrop={'static'} keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <CustomTranslation value={'KEY.Download'} />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Button
                                block
                                variant={'dark'}
                                onClick={() => {
                                    this.setState({ downloadModal: false });
                                    this.downloadFile();
                                }}
                            >
                                <CustomTranslation value={'KEY.PDF file'} />
                            </Button>

                            <Button
                                    block
                                    variant={'dark'}
                                    onClick={async () => {
                                        //set waiting
                                        this.setState({ downloadingFile: true });

                                        //default file name
                                        let now = new Date();
                                        let fileName = await TranslationAction.translate('KEY.Toolbox');
                                        fileName += ' ' + now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
                                        fileName += '.pdf';


                                        //request
                                        APIAction.request('/toolbox/' + this.props.data.id + '/document', 'GET', true, null, true, false, 'json', true)
                                            .then(result => {
                                                fileName = fileName.replace(/['"]+/g, '');
                                                fileDownload(result, fileName, 'application/pdf');
                                            });

                                        this.setState({
                                            downloadingFile: false,
                                            downloadModal: false
                                        });
                                    }}
                                >
                                    <CustomTranslation value={'KEY.Participants list'} />
                                </Button>

                            {this.props.data.document &&
                                <Button
                                    block
                                    variant={'dark'}
                                    onClick={async () => {
                                        //set waiting
                                        this.setState({ downloadingFile: true });

                                        //create file name
                                        let now = new Date();
                                        let fileName = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + '-' + this.props.data.document.originalFileName;

                                        let file = await fetch(this.props.data.document.path, {
                                            method: 'GET',
                                        });
                                        file = await file.blob();

                                        this.setState({
                                            downloadingFile: false,
                                            downloadModal: false
                                        });
                                        fileDownload(file, fileName);
                                    }}
                                >
                                    <CustomTranslation value={'KEY.Document detail'} />
                                </Button>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

//export
export default ToolboxItem;